import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/11/thumb-landscape.jpg"

const Post11 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">HERMES／エヴリンTPM／15 x18 x5cm</span>          
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          エルメス（HERMES）はファッション業界を代表するブランドで知られていますが、始まりは1837年に創業した高級馬具工房でした。1892年に初めて馬鞍を収納するバッグを作成し、それが現在のバーキンの原型と言われています。馬具製作の技術がしっかりと活かされたバッグは現在も受け継がれており、エルメス最大の特徴である洗練されたデザインと美しいシルエットは、今もなお女性を虜にしています♡<br></br>ラクサスでは、好きなブランドバッグをアプリから選ぶだけでレンタルすることができます。なかでもエルメスは、世界中から愛されている人気ブランドで、ラクサスでもよくレンタルされています。<br></br>そこで、ラクサスでの実績などをもとに、みんながよく使っているエルメスの人気バッグを10点選びました。ぜひバッグ選びの参考にしてください！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>エヴリン</h2>
          <p>Hのパンチングがポイント♡洗練されたデザインがカジュアルスタイルも上品に演出してくれます♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/11/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">HERMES／エヴリンⅢPM／27 x26 x6cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/3.jpg" alt="" />
            <span className="text-center">HERMES／エヴリンⅠPM／28 x28 x7cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/4.jpg" alt="" />
            <span className="text-center">HERMES／エヴリンⅡPM／27 x28 x9cm</span> 
          </figure>          
        </div>
        <div className="text-max-width">
          <h2>サンチュール</h2>
          <p>丈夫で軽いキャンバス素材♡開け口が大きく開き、マチもたっぷりあるので収納力抜群！毎日でも使いたくなるバッグです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/6.jpg" alt="" />
          </figure>          
        </div> 
        <span className="text-center">HERMES／プティットサンチュールPM／29 x 24 x 13cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/7.jpg" alt="" />
            <span className="text-center">HERMES／プティットサンチュールPM／30 x24 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/8.jpg" alt="" />
            <span className="text-center">HERMES／プティットサンチュールMM／35 x29 x17cm</span> 
          </figure>
        </div>   
        <div className="text-max-width">
          <h2>サックコロラド</h2>
          <p>緩やかな美しい曲線がポイント♡シンプルな中にエルメスのこだわりが詰まったデザインはカジュアルからフォーマルまで大活躍間違いなし♪</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">HERMES／サックコロラドPM／28 x17 x6cm</span>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/11.jpg" alt="" />
            <span className="text-center">HERMES／サックコロラド／23 x14 x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/12.jpg" alt="" />
            <span className="text-center">HERMES／サックコロラドPM／27 x15 x6cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
          エルメスのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>ピコタン</h2>
          <p>上品さとカジュアルさを兼ね備えたデザインが魅力♡デニムに合わせればおしゃれなストリートスタイルの完成です♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/14.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">HERMES／ピコタンロックPM／18 x18 x13cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/15.jpg" alt="" />
            <span className="text-center">HERMES／ピコタンPM／18 x18 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/16.jpg" alt="" />
            <span className="text-center">HERMES／ピコタンロックPM／18 x18 x13cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
        <h2>カバック</h2>
        <p>エルメスオレンジが素敵♡収納力抜群で、ハンドとショルダーが2つ備わる機能的バッグ！通勤やマザーズバッグとしても大人気です♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">HERMES／カバックPM／30 x25 x10cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/19.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/20.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">HERMES／カバックエランPM／39 x24 x14cm</span> 
        <div className="text-max-width">
          <h2>ヴェスパ</h2>
          <p>エヴリンよりひと回り小ぶりなデザイン。マチやベルトも細くデザインされているので、スタイリッシュな印象になりますよ♡</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/21.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/22.jpg" alt="" />
          </figure>
        </div>      
        <span className="text-center">HERMES／ヴェスパPM／28 x29 x8cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/23.jpg" alt="" />
            <span className="text-center">HERMES／ヴェスパPM／28 x27 x8cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/24.jpg" alt="" />
            <span className="text-center">HERMES／ヴェスパPM／27 x28 x7cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>ヴァルパライソ</h2>
          <p>機能的なのにコンパクト！収納力があるのに、程よいサイズ感が人気の理由♡シンプルで飽きのこないデザインが日常のお出かけにピッタリです♪</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/25.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/26.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">HERMES／ヴァルパライソPM／30 x21 x14cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/27.jpg" alt="" />
            <span className="text-center">HERMES／ヴァルパライソPM／30 x20 x14cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/28.jpg" alt="" />
            <span className="text-center">HERMES／ヴァルパライソPM／29 x19 x13cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
          エルメスのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>エールバッグ</h2>
          <p>キャンバス素材と落ち着いた色味のレザーとの組み合わせが素敵♡カジュアルになりすぎず上品にまとまりますよ♪</p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/29.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/30.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">HERMES／エールバッグPM／30 x25 x11cm</span>               
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/31.jpg" alt="" />
            <span className="text-center">HERMES／エールバッグPM／31 x24 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/32.jpg" alt="" />
            <span className="text-center">HERMES／エールポーチ／24 x18 x4cm</span>
          </figure>       
        </div>
        <div className="text-max-width">
          <h2>ガーデンパーティ</h2>
          <p>シンプルで機能性が高いのが魅力♡下のマチが大きい台形フォルムがフェミニンでやわらかい印象を演出してくれますよ♪</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/33.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/34.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">HERMES／ガーデンパーティPM／36 x26 x16cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/35.jpg" alt="" />
            <span className="text-center">HERMES／ガーデンパーティPM／37 x26 x17cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/36.jpg" alt="" />
            <span className="text-center">HERMES／ガーデンパーティPM／37 x26 x17cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ダルヴィ</h2>
          <p>丸みのあるエレガントなフォルムとワンハンドルのデザインが特徴♡ゴールの金具と明るめブラウンがより上品さを引き立ててくれますね♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/37.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/38.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">HERMES／ダルヴィMM／30 x23 x10cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/39.jpg" alt="" />
            <span className="text-center">HERMES／ダルヴィMM／30 x24 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/40.jpg" alt="" />
            <span className="text-center">HERMES／ダルヴィMM／30 x23 x11cm</span> 
          </figure>
        </div>
        <div className="text-two-cloumn">
          <h2>エレガントを引き立てる<br className="pc"></br>ベージュの魔法♡</h2>
          <p>おしゃれ度の高いワントーンコーデ。エレガントに見せてくれるベージュをセレクト！やぼったく見えそう…そんな時は小物でアクセントを♪バッグやサンダルにブラウンを使えば全体の引き締め効果もあるのでバッチリ！ぜひ参考にしてみてくださいね♪</p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/41.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/11/42.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">HERMES／ピコタンPM／17 x17 x13cm</span>                                          
        <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
          エルメスのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post11

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 11}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
